/**
 * Centralises pdf.js worker wiring.
 *
 * `?url` makes Vite emit the worker as a hashed asset so it can run in
 * its own Web Worker context. Bundling pdf.js as an inline module instead
 * silently breaks all network fetches inside the worker (we shipped that
 * bug once — see commit history on the original PdfPreview).
 *
 * This module is intentionally tiny so test code can mock `./pdfWorker`
 * cleanly without importing the worker URL.
 */
import { GlobalWorkerOptions } from 'pdfjs-dist'
import workerUrl from 'pdfjs-dist/build/pdf.worker.min.mjs?url'

let configured = false

export function configurePdfWorker(): void {
  if (configured) return
  GlobalWorkerOptions.workerSrc = workerUrl
  configured = true
}
